import Select, {Styles} from 'react-select';
import AsyncSelect from 'react-select/async';
import CreatableSelect from 'react-select/creatable';
import styled, {css} from 'styled-components';
import {SelectOptionType} from '../../../utils/types';
import {ErrorMessage} from 'styled/common';
import {device} from 'styled/device';

export const selectWidth = '293px';
export const applySelectStyles = (select: any) => styled(select)`
  // @media (max-width: 330px) {
  //   width: ${selectWidth};
  // }

  .select__control {
    transition: 0.1s;
    border: 1px solid #a2a2b4;
  }

  & .select__value-container {
    padding: 0;
  }

  & .select__dropdown-indicator {
    padding: 0;
  }

  & .select__single-value,
  & .select__placeholder {
    font-family: inherit;
    font-weight: 400;
    font-size: 16px;
    margin-left: 0;
    padding-left: 0;
  }

  & .select__single-value {
    color: #353945ff;
  }

  & .select__placeholder {
    color: #9696b9ff;
  }

  & .select__input input {
    margin: 0;
    padding: 0;
    font-family: inherit;
    font-size: 16px;
    color: #161643;
  }

  & .select__option.select__option--is-selected {
    background-color: #ece9e9;
    font-family: inherit;
    color: #23262f;
    font-weight: 500;
    border-radius: 12px;
  }

  & .select__option.select__option--is-focused.select__option--is-selected {
    cursor: default;
    background-color: #ece9e9;
    font-family: inherit;
    color: #23262f;
    font-weight: 500;
    border-radius: 12px;
  }

  & .select__option.select__option--is-focused {
    cursor: pointer;
    background-color: #f4f5f6;
    font-family: inherit;
    color: #23262f;
    font-weight: 400;
    border-radius: 12px;
  }

  & .select__menu {
    font-family: inherit;
    font-weight: 400;
    color: #777e90;
    font-size: 16px;
    width: ${selectWidth};
    height: auto;
    min-height: 75px;
    max-height: 322px;
    background: #fcfcfd;
    box-shadow: 0 10px 16px #0f0f0f0d;
    border-radius: 0 0 7px 7px;
    z-index: 4;
    margin-top: 0;
  }

  & .select__menu-notice {
    color: #161643;
    text-align: left;
    margin-top: 10px;
    font-size: 16px;
  }

  & .select__menu-list {
    padding: 17px 27px 19px 16px;
    box-shadow: 0 30px 30px #2148ff1a;
    width: ${selectWidth};
    height: auto;
    min-height: 75px;
    max-height: 322px;
    border-radius: 0 0 8px 8px;
  }

  & .select__option {
    text-align: left;
    color: #161643;
    padding: 16px 0 16px 20px;
    box-sizing: border-box;
    background-color: transparent;

    &:active {
      background-color: #f4f5f6;
    }
  }

  & .select__option:last-child {
    border-color: transparent;
  }

  // @media (max-width: ${device.tablet}) {
  //   min-width: 327px;
  // }

  // @media (max-width: ${device.mobileM}) {
  //   min-width: 293px;
  // }
`;

export const styles: Styles<SelectOptionType, boolean> = {
  input: base => ({
    ...base,
    width: 1,
    margin: 0,
    padding: 0,
    fontFamily: 'inherit',
    fontWeight: 500,
    fontSize: 16,
    color: '#161643',
  }),
};

export const ReactSelect = applySelectStyles(Select);
export const AsyncReactSelect = applySelectStyles(AsyncSelect);
export const CreatableReactSelect = applySelectStyles(CreatableSelect);

type WrapperProps = {
  disabled?: boolean;
  invalid?: boolean;
};

export const Wrapper = styled.div<WrapperProps>`
  position: relative;
  box-sizing: border-box;
  display: grid;
  grid-template-rows: auto 50px auto;
  cursor: pointer;
  width: 100%;

  & .select__control {
    grid-row: 2 / 3;
    min-height: 20px;
    cursor: pointer;
    background-color: #fff;
    box-sizing: border-box;
    box-shadow: none;
    border-radius: 7px;
    transition: background-color 0.5s ease-in-out, border-color 0.05s ease-in-out;
    border: 1px solid ${props => (props.invalid ? '#FF2467' : '#a2a2b4')};

    &,
    &:hover {
      border: 1px solid ${props => (props.invalid ? '#FF2467' : '#a2a2b4')};
    }
  }

  & .select__value-container {
    font-family: Poppins, sans-serif;
    padding: 0 9px;
  }

  & .select__placeholder {
    font-family: Poppins-Regular, sans-serif;
    white-space: nowrap;
  }

  ${props =>
    props.disabled &&
    css`
      cursor: not-allowed;
      opacity: 0.3;
    `};
`;

export const Label = styled.label`
  grid-row: 1 / 2;
  font-family: inherit;
  font-size: 12px;
  line-height: 21px;
  text-transform: uppercase;
  margin-bottom: 6px;
  text-align: left;
  user-select: none;
  color: #777e91;
  pointer-events: none;
`;

type DisplayIconProps = {
  shouldRotate: boolean;
};

export const DisplayIcon = styled.div<DisplayIconProps>`
  background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' name='arrow-bottom' size='10' class='' width='10' height='10' viewBox='0 0 16 16'%3E%3Cpath d='M15.039 3.961c-.653-.653-1.713-.653-2.366 0L8 8.634 3.327 3.961c-.653-.653-1.713-.653-2.366 0s-.653 1.713 0 2.366l5.856 5.856c.653.653 1.713.653 2.366 0l5.856-5.856c.653-.653.653-1.713 0-2.366z'%3E%3C/path%3E%3C/svg%3E");
  background-position: center;
  background-repeat: no-repeat;
  background-size: 8px;
  margin-right: 9px;
  pointer-events: none;
  position: relative;
  user-select: none;
  width: 32px;
  height: 32px;
  border-radius: 50%;
  box-shadow: inset 0 0 0 2px #e6e8ec;

  ${props =>
    props.shouldRotate &&
    css`
      transform: rotateX(180deg);
    `};
`;

export const LoaderWrapper = styled.div`
  position: absolute;
  width: 16px;
  top: -27px;
  right: 7px;
`;

export const TooltipWrapper = styled.span`
  margin-left: 6px;
  display: inline-block;
  position: relative;
  pointer-events: auto;
`;

export const Error = styled(ErrorMessage)`
  grid-row: 3 / 4;
`;
